<template>
  <component :is="style">
    .el-loading-spinner .path{ stroke:
    {{ myTheme.topMenu.normal.backgroundColor }} } .bg-primary{
    background-color:{{ myTheme.topMenu.normal.backgroundColor }}; color:{{
      myTheme.topMenu.normal.color
    }}; } .form-control:focus, .el-date-picker .el-input .el-input__inner:focus,
    .form-group .el-input__inner:focus{ border-color:{{
      myTheme.customizeButton.backgroundColor
    }}; } .form-group .el-select .el-input__inne:focus, .el-select
    .el-input.is-focus .el-input__inner,{ border:1px solid
    {{ myTheme.customizeButton.backgroundColor }}; }
    .el-picker-panel.el-date-picker.date-picker-primary { background:{{
      myTheme.customizeButton.backgroundColor
    }}; color :{{ myTheme.customizeButton.color }} !important; }
    .el-picker-panel.el-date-picker.date-picker-primary.el-popper[x-placement^=bottom]
    .popper__arrow:after{ border-bottom-color:
    {{ myTheme.customizeButton.backgroundColor }}; } .date-picker-primary
    .el-picker-panel__content .el-date-table td.current span{ color:{{
      myTheme.customizeButton.backgroundColor
    }}; font-weight: bold } .url-color{ color :
    {{ myTheme.primaryTextColor }} !important } .url-color:hover,
    .url-color:focus{ color : {{ myTheme.secondaryTextColor }} !important }
    .el-select-dropdown__item.selected{ color :{{ myTheme.primaryTextColor }}
    !important; } .el-button:active { color:
    {{ myTheme.customizeButton.color }}; border-color:
    {{ myTheme.customizeButton.color }}; outline: none; } .el-button:focus,
    .el-button:hover { color: {{ myTheme.customizeButton.color }}; border-color:
    {{ myTheme.customizeButton.color }}; background-color:
    {{ myTheme.customizeButton.backgroundColor }}; } .review-item blockquote {
    border-left-color: {{ myTheme.customizeButton.backgroundColor }}; } @media
    screen and (max-width: 991px) { .mobile-bg-primary{ background-color:{{
      myTheme.topMenu.normal.backgroundColor
    }}; color:{{ myTheme.topMenu.normal.color }}; } } .modal-content,
    .dg-main-content{ border:3px solid
    {{ myTheme.topMenu.normal.backgroundColor }}; border-radius : 0.5rem }
    .el-picker-panel.el-date-picker .el-popper[x-placement^=bottom]
    .popper__arrow::after { border-bottom-color:
    {{ myTheme.customizeButton.backgroundColor }}; }
    .el-picker-panel.el-date-picker .el-popper[x-placement^=top]
    .popper__arrow::after { border-top-color:
    {{ myTheme.customizeButton.backgroundColor }}; } .fab-button{ background:
    {{ myTheme.servicesButton.active.backgroundColor }}; border: 0; }
    .tracking-order-cls{ fill:{{ myTheme.servicesButton.active.color }}; }
    .el-message-box{ border: 3px solid
    {{ myTheme.topMenu.normal.backgroundColor }}} .smartbanner-android {
    box-shadow: inset 0 4px 0 {{ myTheme.topMenu.normal.backgroundColor }}; }
    .smartbanner-android .smartbanner-button { color:
    {{ myTheme.servicesButton.active.color }} } .smartbanner-android
    .smartbanner-button-text { background:
    {{ myTheme.servicesButton.active.backgroundColor }}
    } .el-button--primary, .el-button--primary:hover{ background:{{
      myTheme.customizeButton.backgroundColor
    }}; color: {{ myTheme.customizeButton.color }}; border-color:{{
      myTheme.customizeButton.backgroundColor
    }}
    } .form-check .form-check-sign::after{ color:{{
      myTheme.customizeButton.backgroundColor
    }}
    } .el-radio__input.is-checked .el-radio__inner { border-color:
    {{ myTheme.customizeButton.backgroundColor }}; background:
    {{ myTheme.customizeButton.backgroundColor }}; }
    .el-radio__input.is-checked+.el-radio__label { color:
    {{ myTheme.customizeButton.backgroundColor }}; } .el-radio__inner:hover {
    border-color: {{ myTheme.customizeButton.backgroundColor }}; }
    .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
    .el-radio__inner { -webkit-box-shadow: 0 0 2px 2px
    {{ myTheme.customizeButton.backgroundColor }}; box-shadow: 0 0 2px 2px
    {{ myTheme.customizeButton.backgroundColor }}; }
    .account-page .photo, .reviews-page .photo {
      border: 3px solid 
      {{ myTheme.customizeButton.backgroundColor }}
    }
    .text-wtf-custom-color{
      color : {{ myTheme.customizeButton.backgroundColor }}
    }
  </component>
</template>
<script>
export default {
  data() {
    return {
      style: "style",
    };
  },
};
</script>